import { Link } from "react-router-dom";
import Header from "../../components/header/Header";

const Error500 = () =>{
    return(
        <div>
            <Header headerType="detail" headerTitle="" arrowYn={false} closeYn={true}/>
            <div id="container">		
                <div className="content">
                    
                    <div className="vhBox bottomBtn">			
                        <div className="innerBox">
                            <div className="IconWrap">
                                {/* 아이콘 리스트
                                기본 = default , 안내 = .guidance , 실패 = .fail , 성공 = .success */}
                                <div className="icon default"></div>
                                <p className="mediumTit txtBold">
                                    서비스에 접속할 수 없습니다		
                                </p>
                                <p className="normalTit txtBlack2 mt24">
                                    서비스 이용에 불편을 드려 죄송합니다.<br/>
							        잠시 후 다시 이용해 주세요.
                                </p>
                                <p className="normalTit txtBlack2 mt8">
                                    서류제출 메인 화면으로 이동하겠습니다.
                                </p>
                            </div>
                        </div>
                    </div>			
                </div>
                                    
                <div className="fullbtn">
                    {/* 활성화  .on */}
                    <Link to="/" className="btn on">확인</Link>
                </div>
            </div>

        </div>
    );
}
export default Error500;


